import React from 'react';
import { Link } from 'react-router-dom';
import { getActiveTheme } from '../config/themes';
import { useVisualEngine } from '../visual-engine/VisualEngineProvider';

const DEFAULT_EMBLEM = '/emblems/uk.svg';

/**
 * BrandLogo - Centralized TradeLife brand component.
 *
 * Props:
 *   showEmblem  – render the theme emblem (default false)
 *   linkTo      – wraps in a <Link> when set (e.g. "/command-centre")
 *   variant     – "header" (inline, small) | "login" (stacked, larger)
 */
export function BrandLogo({ showEmblem = false, linkTo = null, variant = 'header' }) {
  const theme = getActiveTheme();
  const { themeId } = useVisualEngine();
  const isMoltenTheme = themeId === 'molten';
  const showMoltenWordmark = isMoltenTheme && variant === 'header';
  const emblemSrc = theme.loginEmblem || DEFAULT_EMBLEM;

  const variantClass = variant === 'login' ? 'brand-logo--login' : 'brand-logo--header';

  const inner = (
    <div className={`brand-logo ${variantClass}`} data-testid="brand-logo">
      {showEmblem && (
        <img
          src={emblemSrc}
          alt="Theme Emblem"
          className="brand-emblem"
          data-testid="brand-emblem"
        />
      )}
      <span className={`brand-title ${showMoltenWordmark ? 'brand-title--molten' : ''}`}>
        <span className="logo-trade">Trade</span>
        <span className="logo-life">Life</span>
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="brand-logo-link" data-testid="nav-logo">
        {inner}
      </Link>
    );
  }

  return inner;
}

export default BrandLogo;
